import { Button, Center, Image, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Spacer, Text, toast, VStack } from '@chakra-ui/react';
import { AccountContext } from 'components/AccountContext';
import React, { useContext, useState } from 'react';
import BemVindo from '../../images/BemVindo.svg';
import { useNavigate } from 'react-router-dom';
import { api } from 'api/api';

function ModalClienteImportado(props) {
  const disclosure = props.disclosure;
  const { user, setUser } = useContext(AccountContext);
  let usuarioAssinante = user.id_contrato && user.descricao_plano ? true : false;
  if (user.titular === false) usuarioAssinante = true;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function fetchMensalidades(botaoEnviar) {
    setLoading(true);
    const ENDPOINT =
      process.env.REACT_APP_ENVIRONMENT === 'production'
        ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
        : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;
    const url = `${ENDPOINT}/client/parcelas`;

    try {
      const response = await api(url, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
          id_contrato: user?.clienteImportado?.clientImportado === true
          ? user?.clienteImportado?.empreendedor?.contrato_id
          : user.titular
          ? user.id_contrato
          : user.id_contrato_dependent.paciente_contrato_id,
          titular: user.titular,
          id_contrato_dependente: user.id_contrato_dependent,
          adesaoImportada: user?.clienteImportado?.clientImportado
        }),
      });

      const postsData = await response.json();
      setLoading(false);
      if (postsData?.length === 0) {
        if (!botaoEnviar) {
          setUser((prevState) => ({ ...prevState, qntdeParcelas: null, clienteImportado: false }));
          disclosure.onClose();
          return;
        }
        navigate('/dashboard/financeiro/sucesso-pagamento');
      } else {
        if (botaoEnviar) {
          navigate('/pagamentoparcelas');
          return;
        }
        disclosure.onClose();
      }
    } catch (error) {
      setLoading(false);
      console.error('Erro ao carregar mensalidades:', error);
    }
  }
  return (
    <>
      <Modal isOpen={disclosure.isOpen} isCentered>
        <ModalOverlay />
        <ModalContent maxW="95%" h="auto" borderRadius="0.8em">
          <ModalCloseButton
            mt={1}
            color={'#9E9E9E'}
            onClick={() => {
              fetchMensalidades();
            }}
            _focus={false}
          />
          <ModalBody>
            <VStack align={'left'} borderBottom={'0.1px black'}>
              <Text color={'#9E9E9E'} mt={2}>
                Confirmação do Contrato
              </Text>
            </VStack>
            {/* Removido Spacer para evitar espaço extra ao final do modal */}
            <VStack>
              <Image src={BemVindo} mt={4} w={'100%'} />
              <Text color={'#616161'} fontWeight={'bold'} fontSize={'1.5em'} textAlign={'center'} letterSpacing={'-0.05em'}>
                Seja bem-vindo
                <br />
                ao app DeoVita! 😄
              </Text>
              <Text color={'#757575'} textAlign={'center'} fontWeight={'bold'} fontSize={'17px'} letterSpacing={'-0.05em'}>
                Falta só um passinho para você começar a usar seu app de saúde.
              </Text>
              <Text color={'#616161'} textAlign={'center'} fontSize={'17px'} letterSpacing={'-0.05em'}>
                Confirme sua assinatura inserindo os dados do cartão e finalizando o pagamento. Depois disso, é só aproveitar!
              </Text>
            </VStack>
            <Center mt={2} mb={2}>
              <Button
                color={'white'}
                bg={usuarioAssinante ? '#5AB2AE' : '#5AB2AE'}
                borderRadius={'0.8em'}
                w={'100%'}
                onClick={() => {
                  const botaoEnviar = true;
                  if (user?.cards?.length === 0) {
                    //não tem cartão eu levo ele pra cadastrar
                    navigate('/perfil/dados-bancarios', { state: { importado: true } });
                    return;
                  }
                  //caso ele ja tenha cartão, ai eu mostro pra ele ir pras parcelas pagar
                  fetchMensalidades(botaoEnviar);
                }}
                isLoading={loading}
                isDisabled={loading}
              >
                Vamos começar!
              </Button>
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ModalClienteImportado;
